import styled, { css } from "styled-components";
import tw from "twin.macro";

import { IPaperProps } from "./Paper";
import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";

export const PaperStyles = css`
  ${tw`tw-bg-page-paper-main`}
  border-radius: var(--ac-br-8);

  ${FontStyle}
  ${BoxSizingStyle}
`;
export const StyledPaper = styled.div<IPaperProps>`
  ${PaperStyles}

  ${(props) =>
    props.type === "paper-3" &&
    css`
      border: solid 1px var(--border-primary);
    `}
    
    ${(props) =>
    props.type === "tile-1" &&
    css`
      border: solid 1px var(--color-theme-300);
    `}

    ${(props) =>
    (props.type === "tile-1" || props.type === "tile-2") &&
    css`
      &:hover {
        background-color: var(--color-theme-200);
      }
    `}
`;

StyledPaper.displayName = "StyledPaper";
